import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import Input, { type InputProps } from "./Input";

export interface PasswordInputProps
  extends Omit<InputProps, "type" | "rightIcon"> {
  showPasswordLabel: string;
  hidePasswordLabel: string;
}

const toggleButtonClassName =
  "rounded-md p-0.5 text-surface-500 transition-colors hover:bg-surface-50 hover:text-surface-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40";

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ showPasswordLabel, hidePasswordLabel, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
      <Input
        ref={ref}
        type={showPassword ? "text" : "password"}
        rightIcon={
          <button
            type="button"
            className={toggleButtonClassName}
            onClick={() => setShowPassword((visible) => !visible)}
            aria-label={showPassword ? hidePasswordLabel : showPasswordLabel}
          >
            {showPassword ? (
              <EyeOff className="h-5 w-5" aria-hidden />
            ) : (
              <Eye className="h-5 w-5" aria-hidden />
            )}
          </button>
        }
        {...props}
      />
    );
  },
);

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
